<script>
import checkbox from '../checkbox.vue'
import isEqual from 'lodash/isEqual'
import each from 'lodash/forEach'
import findIndex from 'lodash/findIndex'

export default {
  mixins: [checkbox],
  name: 'geoCheckbox',

  methods: {
    toggle() {
      let value;
      if (Array.isArray(this.modelValue)) {
        value = this.modelValue.slice(0);
        if (this.state) {
          let indexOf = findIndex(value, {'text': this.value.text, 'id': this.value.id});
          value.splice(indexOf, 1);
        } else {
          value.push(this.value);
        }
      }
      this.$emit('input', value);
    }
  },

  computed: {
    state: {
      get(){
        let checked = false;
        if (Array.isArray(this.modelValue)) {
          let this_value = this.value;
          each(this.modelValue, function(model_value) {
            checked = isEqual(model_value, this_value);
            return !checked;
          });
        }
        return checked;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/geo/geo-checkbox.vue